import { type ReactElement, type SVGProps } from 'react';

export const PropertyBuilding = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12.9838 8.00006V5H13.9834V8.00006H12.9838Z" fill="currentColor" />
      <path d="M15.9828 5V8.00006H16.9824V5H15.9828Z" fill="currentColor" />
      <path d="M12.9838 13.0006V10.0005H13.9834V13.0006H12.9838Z" fill="currentColor" />
      <path d="M15.9828 10.0005V13.0006H16.9824V10.0005H15.9828Z" fill="currentColor" />
      <path d="M12.9838 18.0005V15.0005H13.9834V18.0005H12.9838Z" fill="currentColor" />
      <path d="M15.9828 15.0005V18.0005H16.9824V15.0005H15.9828Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99859 3H19.9948V20.0002H21.0039V21.0002H4.00085V14.9736H5.00047V20.0002H9.99859V3ZM18.9952 4V20.0002H10.9982V4H18.9952Z"
        fill="currentColor"
      />
      <path d="M3.64953 13.8195L9.56038 8.81716L8.91475 8.05371L3.00391 13.0561L3.64953 13.8195Z" fill="currentColor" />
    </svg>
  );
};
